import { render, staticRenderFns } from "./Associate.vue?vue&type=template&id=9c72595c&"
import script from "./Associate.vue?vue&type=script&async=true&defer=true&lang=js&"
export * from "./Associate.vue?vue&type=script&async=true&defer=true&lang=js&"
import style0 from "./Associate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports